import { imageOptions } from '#build/image-options'

/**
 * `image.densities` de nuxt.config est fusionné par CONCATÉNATION (defu)
 * avec le défaut [1, 2] de @nuxt/image → [1, 1, 2] dans le build : la
 * config seule ne peut pas désactiver les variantes @2x. On corrige ici
 * l'objet partagé, avant la première création de $img (SSR et client).
 * Chaque variante @2x est une transformation Cloudflare facturée en plus.
 */
export default defineNuxtPlugin(() => {
  imageOptions.densities = [1]
})
